import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { captureApiException } from '@/utility/sentry'

const bitrixApi = import.meta.env.VITE_BITRIXAPI

export const useMessagesStore = defineStore('messages', () => {

    const messages = ref([])
    const unreadCount = ref(0)
    const loading = ref(false)
    const projectName = ref('')
    const dataLoaded = ref(false)

    let controller = null
    let fetchInFlight = null

    async function fetchMessages() {
        if (fetchInFlight)
            return fetchInFlight

        if (controller) controller.abort()
        controller = new AbortController()

        loading.value = true

        const token = localStorage.getItem('id_token_portalbitrix')
        
        const request = (async () => {
            try {
                const response = await axios.get(bitrixApi + 'partner/messagesV2?inbox=true&page=1&size=1', {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        'x-localization': 'da'
                    },
                    signal: controller.signal
                })

                const res = response.data.data
                unreadCount.value = res.unread
                messages.value = res.items || []
                loading.value = false

                return res
            } catch (error) {
                loading.value = false

                if (!axios.isCancel(error)) {
                    ElMessage.error(error?.response?.data?.message || 'Der opstod en fejl')
                    captureApiException(error, 'messages.js', 'fetchMessages')
                    throw error
                }
                return null
            } finally {
                if (fetchInFlight === request)
                    fetchInFlight = null
            }
        })()

        fetchInFlight = request
        return request
    }

    function cancelFetch() {
        if (controller) {
            controller.abort()
            controller = null
        }
    }

    function setProjectName (name) {
        projectName.value = name
    }

    const resetMessages = () => {
        messages.value = []
        unreadCount.value = 0
        loading.value = false
        projectName.value = ''
        dataLoaded.value = false
    }

    return {
        messages,
        loading,
        unreadCount,
        fetchMessages,
        cancelFetch,
        projectName,
        dataLoaded,
        setProjectName,
        resetMessages
    }
})
